var highUrl = process.env.NODE_ENV === 'development' ? "http://10.10.11.250:714/#" : 'http://slczpc.sunray365.com/#'

export default highUrl